/**
 * @generated SignedSource<<b4ece4b6036e91d1775efdfec9411555>>
 * @relayHash 370066bf9ce4ce5f60f0e4c67a1704e1
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 370066bf9ce4ce5f60f0e4c67a1704e1

import { ConcreteRequest } from 'relay-runtime';
export type De_signPrescriptionDocumentInput = {
  id: string;
};
export type useDeSignPrescriptionMutation$variables = {
  input: De_signPrescriptionDocumentInput;
};
export type useDeSignPrescriptionMutation$data = {
  readonly de_signPrescriptionDocument: {
    readonly errors: ReadonlyArray<{
      readonly errorType?: string;
      readonly message?: string;
    }> | null;
    readonly qesSigningResponse: {
      readonly requestId: string;
      readonly signingRequestUrl: any;
    } | null;
  };
};
export type useDeSignPrescriptionMutation = {
  response: useDeSignPrescriptionMutation$data;
  variables: useDeSignPrescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "QesSigningResponse",
  "kind": "LinkedField",
  "name": "qesSigningResponse",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requestId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signingRequestUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "SignDocumentMutationFailed",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeSignPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_signPrescriptionDocumentPayload",
        "kind": "LinkedField",
        "name": "de_signPrescriptionDocument",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeSignPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_signPrescriptionDocumentPayload",
        "kind": "LinkedField",
        "name": "de_signPrescriptionDocument",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "370066bf9ce4ce5f60f0e4c67a1704e1",
    "metadata": {},
    "name": "useDeSignPrescriptionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "11488ce61a142bcd5176a755f12cc752";

export default node;
